interface EnvelopeType {
  closedBack?: string;
}

interface EnvelopeClosedFlapProps {
  envelope?: EnvelopeType;
}

export const EnvelopeClosedFlap = ({envelope}: EnvelopeClosedFlapProps) => (
  <div className="env-wrapper closed-flap env-final">
    <div className="env-group env-group__closed-flap">
      <img className="invite-envelope__full-width" src={envelope?.closedBack} alt="" />
    </div>
  </div>
);
